import api from './client';

export interface CampaignData {
  name: string;
  phone_numbers: string[];
  script: string;
  voice?: string | undefined;
  scheduled_at?: string | undefined;
}

export async function getCampaigns() {
  const { data } = await api.get('/api/v1/campaigns');
  return data;
}

export async function createCampaign(campaignData: CampaignData) {
  const { data } = await api.post('/api/v1/campaigns', campaignData);
  return data;
}

export async function getCampaignResults(id: string) {
  const { data } = await api.get(`/api/v1/campaigns/${id}/results`);
  return data;
}

export async function pauseCampaign(id: string) {
  const { data } = await api.post(`/api/v1/campaigns/${id}/pause`);
  return data;
}
